export const PUBLIC_OPEN_ED_API = import.meta.env.VITE_PUBLIC_OPEN_ED_API ?? ''
